module.exports = __webpack_public_path__ + "static/media/background.73c0cb9f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cities/denver/background.jpg
// module id = 936
// module chunks = 27